import React from "react";
import { useLang } from "../i18n";
import { Contact } from "../components/site/Contact";
import { Seo, localBusinessJsonLd } from "../components/site/Seo";

export default function ContactPage() {
  const { lang } = useLang();
  return (
    <>
      <Seo
        title={lang === "fr" ? "Contact & devis drone gratuit | Fixedrone Luxembourg" : "Contact & free drone quote | Fixedrone Luxembourg"}
        description={lang === "fr" ? "Contactez Fixedrone pour un devis gratuit : inspection, thermographie, cartographie ou agriculture par drone au Luxembourg (Senningerberg) et régions frontalières. Réponse sous 24-48 h." : "Contact Fixedrone for a free quote: drone inspection, thermography, mapping or agriculture in Luxembourg (Senningerberg) and border regions. Reply within 24-48h."}
        keywords="contact drone Luxembourg, devis drone, Fixedrone Senningerberg, inspection drone devis"
        path="/contact"
        jsonLd={localBusinessJsonLd}
      />
      <div className="pt-20 bg-[#070708]">
        <Contact />
      </div>
    </>
  );
}
